import { http } from '@/helpers/http';

export const user = {
    namespaced: true,

    state: {
        user: null,
    },

    mutations: {
        setUser (state, user) {
            state.user = { ...user };
        },
    },

    actions: {
        async getUser ({ commit }) {
            const { data } = await http.post('/admin/users/details');
            commit('setUser', data);
        },

        async login ({ commit }, params) {
            try {
                const { data } = await http.post('/auth/login', params);
                commit('setUser', data);
                return data;
            } catch (e) {
                throw e;
            }
        },

        async logout ({ commit }) {
            const { data } = await http.get('/auth/logout');
        }
    },
};

export default user;
